export default {
  users: (state) => state.users,
  loading: (state) => state.loading,
}
